const globalBlocks = []

export const setGlobalQueryBlocks = (blocks) => {
  globalBlocks.splice(0, globalBlocks.length, ...blocks)
}

export const getGlobalQueryBlocks = () => [...globalBlocks]